import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const ReportsIcon = ({
  currentImage,
  isExpanded,
  disabled,
  returnPath,
  open,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.reports;
    const expanded = isExpanded === `panel${MENU_KEYS.reports}`;
    const path =
      returnPath('/portafolio-modelo/honorarios') ||
      returnPath('/portafolio-modelo/inversion') ||
      returnPath('/portafolio-modelo/reportes-operacion') ||
      returnPath('/portafolio-modelo/fondos') ||
      returnPath('/portafolio-modelo/reporte-liquidez') ||
      returnPath('/portafolio-modelo/documental');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };
  if (disabled && currentImage !== MENU_KEYS.reports)
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          d="M17.8889 17.4V14.1C17.8889 13.8083 18.0177 13.5285 18.2469 13.3222C18.4761 13.1159 18.787 13 19.1111 13H33.7778C34.1019 13 34.4128 13.1159 34.642 13.3222C34.8712 13.5285 35 13.8083 35 14.1V29.5C35 29.7917 34.8712 30.0715 34.642 30.2778C34.4128 30.4841 34.1019 30.6 33.7778 30.6H30.1111V33.9C30.1111 34.5072 29.5611 35 28.8803 35H14.2308C14.0696 35.0009 13.9098 34.973 13.7606 34.9182C13.6114 34.8633 13.4757 34.7824 13.3614 34.6802C13.247 34.578 13.1562 34.4564 13.0942 34.3225C13.0322 34.1887 13.0002 34.045 13 33.9L13.0037 18.5C13.0037 17.8928 13.5537 17.4 14.2332 17.4H17.8889ZM15.4469 19.6L15.4444 32.8H27.6667V19.6H15.4469ZM20.3333 17.4H30.1111V28.4H32.5556V15.2H20.3333V17.4ZM17.8889 22.9H25.2222V25.1H17.8889V22.9ZM17.8889 27.3H25.2222V29.5H17.8889V27.3Z"
          fill="#757A96"
        />{' '}
      </svg>
    );

  if (logicOp()) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#F4F2F9" />
        <path
          d="M17.8889 17.4V14.1C17.8889 13.8083 18.0177 13.5285 18.2469 13.3222C18.4761 13.1159 18.787 13 19.1111 13H33.7778C34.1019 13 34.4128 13.1159 34.642 13.3222C34.8712 13.5285 35 13.8083 35 14.1V29.5C35 29.7917 34.8712 30.0715 34.642 30.2778C34.4128 30.4841 34.1019 30.6 33.7778 30.6H30.1111V33.9C30.1111 34.5072 29.5611 35 28.8803 35H14.2308C14.0696 35.0009 13.9098 34.973 13.7606 34.9182C13.6114 34.8633 13.4757 34.7824 13.3614 34.6802C13.247 34.578 13.1562 34.4564 13.0942 34.3225C13.0322 34.1887 13.0002 34.045 13 33.9L13.0037 18.5C13.0037 17.8928 13.5537 17.4 14.2332 17.4H17.8889ZM15.4469 19.6L15.4444 32.8H27.6667V19.6H15.4469ZM20.3333 17.4H30.1111V28.4H32.5556V15.2H20.3333V17.4ZM17.8889 22.9H25.2222V25.1H17.8889V22.9ZM17.8889 27.3H25.2222V29.5H17.8889V27.3Z"
          fill="#6D46DD"
        />{' '}
      </svg>
    );
  }

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="#525067" />
      <path
        d="M17.8889 17.4V14.1C17.8889 13.8083 18.0177 13.5285 18.2469 13.3222C18.4761 13.1159 18.787 13 19.1111 13H33.7778C34.1019 13 34.4128 13.1159 34.642 13.3222C34.8712 13.5285 35 13.8083 35 14.1V29.5C35 29.7917 34.8712 30.0715 34.642 30.2778C34.4128 30.4841 34.1019 30.6 33.7778 30.6H30.1111V33.9C30.1111 34.5072 29.5611 35 28.8803 35H14.2308C14.0696 35.0009 13.9098 34.973 13.7606 34.9182C13.6114 34.8633 13.4757 34.7824 13.3614 34.6802C13.247 34.578 13.1562 34.4564 13.0942 34.3225C13.0322 34.1887 13.0002 34.045 13 33.9L13.0037 18.5C13.0037 17.8928 13.5537 17.4 14.2332 17.4H17.8889ZM15.4469 19.6L15.4444 32.8H27.6667V19.6H15.4469ZM20.3333 17.4H30.1111V28.4H32.5556V15.2H20.3333V17.4ZM17.8889 22.9H25.2222V25.1H17.8889V22.9ZM17.8889 27.3H25.2222V29.5H17.8889V27.3Z"
        fill="#F4F2F9"
      />
    </svg>
  );
};

export default ReportsIcon;
